import React from "react";
import { DrawerType } from "constants/TemplateEditor";
import { SectionRule, TemplateRule } from "./Components";
import "./ruleEditor.scss";

interface IRuleEditor {
  drawerType: any;
  onCancel: () => void;
}

const RuleEditor: React.FC<IRuleEditor> = (props) => {
  const { drawerType, onCancel } = props;

  return (
    <>
      {drawerType == DrawerType.SECTION_RULES ? (
        <SectionRule onCancel={onCancel} />
      ) : (
        <TemplateRule onCancel={onCancel} />
      )}
    </>
  );
};

export default RuleEditor;
